module.exports = "<navbar></navbar>   \r\n\r\n<div class=\"container\">\r\n    \r\n    <!-- CARREGA A ROTA QUE ESTIVER APONTANDO A URL -->\r\n    <router-outlet></router-outlet>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/xampp2/htdocs/angular-front/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main